<template>

  <app-modal
      :modal-id="modalId"
      :title="title"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
      modal-size="large"
      modal-alignment="top"
  >

    <template slot="header">
      <h5 class="modal-title">{{title}}</h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="
          selectedUrl
            ? `/treasury/elaborateProforma/attachProforma/rate/saveItem/${inputs.id}`
            : `/treasury/elaborateProforma/attachProforma/rate/saveItem`
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Ingrese los días</label>
              <app-input
                  type="number"
                  v-model="inputs.days"
                  placeholder="Ingrese el número de días"
                  :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Seleccione una tasa</label>
              <app-input
                  type="select"
                  v-model="inputs.rate_id"
                  :required="true"
                  :list="ratesList"
              />
            </div>
          </div>



        </div>

      </form>
    </template>

    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>



  </app-modal>

</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin.js";
import {TREASURY_PROFORMA} from "../../../../apiUrl";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    proformGeneratedId: String
  },
  data() {
    return {
      preloader: false,
      inputs: {
        proform_generated_id: this.proformGeneratedId
      },
      ratesList: [],
      disabled: false,
      modalId: "proform-detail-modal",
    };
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
    this.getRates();
  },
  methods: {
    submit() {
      this.inputs.days = Number(this.inputs.days);
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (response.data.proformTotal){
        this.$store.commit('updateProformTotal', response.data.proformTotal);
      }

      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    getRates(){
      const url = `${TREASURY_PROFORMA}/getAllRates`;
      this.axiosGet(url).then((response)=>{
        this.ratesList =  [{id: "", value: "Selecccione una opción"}, ...response.data]
      })
    }
  },
  computed:{
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    }
  }

}
</script>
